import React, { useState } from "react";
import { Button, Alert } from "@mantine/core";
import fetchApi from "../components/Lib/api";
import styled from "styled-components";

const PrimaryButton = styled.button`
  border-radius: 4px;
  background: #3566fd;
  color: #fff;
  padding: 4px 10px;
  font-size: 11px;
  width: 100%;
  z-index: 100;
  &:hover {
    background-color: #fff;
    color: #007bff;
  }
`;

const ProjectApplyButton = ({
  startupSlug,
  isOwner = false,
  size = "sm",
  variant = "filled",
  color = "blue",
  className = "",
  disabled = false,
  has_applied,
  children = has_applied ? "Veiw Application" : "Apply Now",
}) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleClick = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    // If owner, redirect to startup page
    if (isOwner) {
      window.location.href = `/projects/${startupSlug}`;
      return;
    }

    setLoading(true);
    setError(null);

    if (!startupSlug) {
      setError("Startup slug is missing. Cannot apply.");
      setLoading(false);
      return;
    }

    try {
      // First, check if user already has an application
      const checkResponse = await fetchApi(
        `/startup_entities/${startupSlug}/applications`,
        "GET"
      );

      if (checkResponse.ok) {
        const data = await checkResponse.json();
        if (data.applications && data.applications.length > 0) {
          // Find user's solo application (not squad application)
          const userApplication = data.applications.find(
            (app) => app.user && !app.squad
          );
          if (userApplication) {
            // User already has an application, redirect to it
            window.location.href = `/applications/${userApplication.slug}`;
            return;
          }
        }
      }

      // No existing application found, create a new one
      const applicationPayload = {
        application: {
          pitch: "This is a default application pitch.",
        },
      };

      const createResponse = await fetchApi(
        `/startup_entities/${startupSlug}/applications`,
        "POST",
        applicationPayload
      );

      if (!createResponse.ok) {
        const errorData = await createResponse.json().catch(() => ({}));
        throw new Error(
          errorData.error || errorData.message || "Failed to create application"
        );
      }

      const createData = await createResponse.json();

      if (createData.application && createData.application.slug) {
        window.location.href = `/applications/${createData.application.slug}`;
      } else {
        throw new Error("Application slug not returned from API");
        setLoading(false);
      }
    } catch (err) {
      console.error("Error handling application:", err);
      setError(err.message || "An unexpected error occurred.");
      setLoading(false);
    }
  };

  return (
    <>
      <PrimaryButton
        onClick={handleClick}
        loading={loading}
        disabled={disabled || loading}
      >
        {loading ? "Processing..." : isOwner ? "View Applications" : children}
      </PrimaryButton>

      {error && (
        <Alert color="red" size="sm" mt="xs">
          {error}
        </Alert>
      )}
    </>
  );
};

export default ProjectApplyButton;
